// extracted by mini-css-extract-plugin
export default {"recordDrawer":"serviceRecoed_recordDrawer__2nt5O","fourButton":"serviceRecoed_fourButton__-yUqj"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"recordDrawer\":\"serviceRecoed_recordDrawer__2nt5O\",\"fourButton\":\"serviceRecoed_fourButton__-yUqj\"}";
        // 1793760840765
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  